import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Barcode from "react-barcode";

export default function Voucher() {
  const [searchParams] = useSearchParams();
  const couponcode = searchParams.get("couponcode");
  console.log("xxx", couponcode);
  return (
    <>
      <div id="pageVoucher">
        <main>
          <div className="wrapContent">
            <section id="pVoucher">
              <div className="bVoucherContent">
                <div className="bTop">
                  <div className="bContent">
                    <div className="bPic">
                      <img
                        src="/assets/img/ci/voucher/voucher.png"
                        alt="Voucher"
                      />
                    </div>
                  </div>
                </div>
                <div className="bBottom">
                  <div className="bContent">
                    <div className="bBarcode">
                      {/* sample value */}
                      <Barcode value={couponcode} />
                    </div>
                    <p className="tExpire">
                      วันหมดอายุ : 13 กุมภาพันธ์ 2569 เวลา 23:59
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
    </>
  );
}
